import graphql__f04e9c7ca41a7914b0b5 from "./__generated__/InterviewChatSection_answer.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { INTERVIEW_UI_STATE_THINKING } from "./oralInterviewUiTransitions";
import InterviewChatMessage from "./InterviewChatMessage";

const InterviewChatSection = ({ interviewUiState, ...props }) => {
  const { messages } = useFragment(InterviewChatSection_answer, props.answer);
  const t = useFormatMessage();
  const thinkingMessage = t(intlMessages.stateThinking);

  const thinkingRowClassName = classNames(
    "oral-interview-chat__row",
    "oral-interview-chat__row--assistant",
    "oral-interview-chat__row--thinking"
  );
  const thinkingBubbleClassName = classNames(
    "oral-interview-chat__bubble",
    "oral-interview-chat__bubble--thinking"
  );

  return (
    <div className="oral-interview-chat">
      {messages.map((message, index) => (
        <InterviewChatMessage key={index} message={message} />
      ))}

      {interviewUiState === INTERVIEW_UI_STATE_THINKING && (
        <div className={thinkingRowClassName}>
          <div className={thinkingBubbleClassName}>
            <span className="oral-interview-chat__typing-dot" />
            <span className="oral-interview-chat__typing-dot" />
            <span className="oral-interview-chat__typing-dot" />
          </div>
          <p className="oral-interview-chat__thinking">{thinkingMessage}</p>
        </div>
      )}
    </div>
  );
};

const InterviewChatSection_answer = graphql__f04e9c7ca41a7914b0b5;

export default InterviewChatSection;

const intlMessages = defineMessages({
  stateThinking: {
    id: "answer.oralInterview.stateThinking",
    defaultMessage: "L'interviewer réfléchit..."
  }
});
